import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Breadcrumb from '@/components/base/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { categories as categoriesData } from '@/mocks/jinman';

export default function Categories() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || categoriesData[0].id;
  const [isChanging, setIsChanging] = useState(false);

  const activeCategory = categoriesData.find((c) => c.id === activeTab) || categoriesData[0];

  const handleTabChange = (tabId: string) => {
    if (tabId === activeTab) return;
    setIsChanging(true);
    setSearchParams({ tab: tabId });
    setTimeout(() => setIsChanging(false), 150);
  };

  return (
    <>
      <SchemaOrg type="WebPage" data={{ name: 'jinman - 产品分类', description: '浏览jinman的完整产品分类，包括智能硬件、数字服务、生活美学和企业方案。' }} />
      <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '产品分类' }]} />

      <section className="bg-background-50 py-10 md:py-14" aria-labelledby="categories-heading">
        <div className="w-full px-4 md:px-6">
          <div className="text-center mb-10">
            <h1 id="categories-heading" className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              产品分类
            </h1>
            <p className="text-sm text-foreground-600 max-w-xl mx-auto">
              探索 jinman 四大业务板块，找到最适合您的产品与服务
            </p>
          </div>

          {/* Tab Switcher */}
          <div className="flex items-center justify-center mb-10">
            <div className="inline-flex bg-background-100 rounded-full px-1 py-1" role="tablist" aria-label="产品分类切换">
              {categoriesData.map((cat) => (
                <button
                  key={cat.id}
                  role="tab"
                  aria-selected={activeTab === cat.id}
                  onClick={() => handleTabChange(cat.id)}
                  className={`px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                    activeTab === cat.id
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200/70'
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5`}></i>
                  {cat.name}
                </button>
              ))}
            </div>
          </div>

          {/* Category Description */}
          <div className="text-center mb-10 transition-opacity duration-150" style={{ opacity: isChanging ? 0.3 : 1 }}>
            <p className="text-sm text-foreground-600 max-w-2xl mx-auto leading-relaxed">
              {activeCategory.description}
            </p>
          </div>

          {/* Products Grid */}
          <div
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto transition-opacity duration-150"
            style={{ opacity: isChanging ? 0.3 : 1 }}
          >
            {activeCategory.products.map((product, idx) => (
              <div
                key={product.name}
                className="bg-background-100 rounded-lg overflow-hidden group cursor-pointer"
                data-product-shop
              >
                <div className="h-48 overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-base text-foreground-900 mb-1">{product.name}</h3>
                  <p className="text-xs text-foreground-600">{product.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}